<div [class.loader-hidden]="!show">
  <div class="loader-overlay">
    <div>
      <mat-progress-bar mode="indeterminate"
                        color="primary"
                        *ngIf="show"></mat-progress-bar>
    </div>
  </div>
</div>
